<div class="sectionWrapper">
  <h2 id="{{ sectionId }}Title" class="cald-heading toggle-section-trigger" [ngClass]="{ 'error-text-color': hasError, 'toggled': isToggled }" (click)="toggleSection($event)">
    {{ sectionTitle | translate }}
    @if (hasError) {
      <span class="sap-icon">&#xe1f7;</span>
    }
    @if (isRequired) {
      <span class="required">*</span>
    }
    <ng-content select="cpq-info"></ng-content> <!-- placeholder for cpq-info component -->
  </h2>
  <div id="{{ sectionId }}" class="collapsible-section">
    <ng-content></ng-content>
  </div>
</div>
